// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__BWxNY","colMin":"styles_colMin__BWZOl","colCheckbox":"styles_colCheckbox__1lmhM"};